<template>
  <b-container v-if="path || isEmbed">
    <prismic-rich-text v-if="title" :field="title" class="title"></prismic-rich-text>
    <prismic-rich-text
      v-if="subtitle"
      :field="subtitle"
      class="title video-subtitle"
    ></prismic-rich-text>
    <Video :path="path" :options="options" />
  </b-container>
</template>

<script>
import Video from '@/components/Common/Video.vue';

export default {
  components: {
    Video
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      path: '',
      title: '',
      subtitle: '',
      options: {}
    };
  },
  created() {
    this.path = this.slice.primary.path ? this.slice.primary.path : '';
    this.title = this.slice.primary.title1[0]?.text ? this.slice.primary.title1 : '';
    this.subtitle = this.slice.primary.subtitle[0]?.text ? this.slice.primary.subtitle : '';
    this.isEmbed = this.slice.primary?.is_embed;

    if (this.isEmbed) {
      this.options = {
        language: 'en',
        playbackRates: [1.0],
        sources: [
          {
            type: 'video/mp4',
            src: this.path
          }
        ],
        poster: this.slice.primary.poster ? this.slice.primary.poster : ''
      };
      this.path = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  text-align: left;
  font-size: 2em;
  font-family: 'Poppins', sans-serif;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  padding-bottom: 20px;
}
.video-subtitle {
  font-size: 1.5em;
}
</style>
